import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';
import { MatIcon } from '@angular/material/icon';
import { TranslocoDirective } from '@jsverse/transloco';
import { TranslocoDatePipe } from '@jsverse/transloco-locale';
import { SignerDetailVariant, signerStatusBoxConfigMapper } from '@dss-libs/portal/type/portal-types';

@Component({
  selector: 'dss-libs-feature-signer-status-box',
  imports: [TranslocoDirective, TranslocoDatePipe, MatIcon],
  templateUrl: './signer-status-box.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SignerStatusBoxComponent {
  readonly variant = input.required<SignerDetailVariant>();
  readonly actionDate = input<string | undefined>();
  readonly ipAddress = input<string | undefined>();
  readonly expiryDate = input.required<string>();
  readonly daysRemaining = input<number | null>(null);

  protected readonly config = computed(() => signerStatusBoxConfigMapper.get(this.variant())!);
}
